import { ReactNode } from "react";
import { get, isEmpty, map } from "lodash";
import {
  Controller,
  UseFieldArrayReturn,
  useFormContext,
} from "react-hook-form";
import classNames from "classnames";
import TranslatableTextInput from "../../shared/multilingualism/TranslatableTextInput";

type SurveyFieldsArgs = {
  fields: UseFieldArrayReturn["fields"];
  removeButton: (index: number) => ReactNode;
};
export default function SurveyFields({
  fields,
  removeButton,
}: SurveyFieldsArgs) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <div className="flex flex-col gap-2">
        {map(fields, (field, index) => {
          return (
            <div className="flex items-center gap-2" key={field.id}>
              <Controller
                name={`object.options.${index}`}
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value, ...field } }) => (
                  <TranslatableTextInput
                    {...field}
                    containerClassName="flex-1 min-w-0"
                    className={classNames("form-control", {
                      "field-error field-error-live":
                        !!get(errors, [
                          "object",
                          "options",
                          "root",
                          "message",
                        ]) && isEmpty(value.label),
                    })}
                    value={value?.label || ""}
                    translationsValue={value?.translations || {}}
                    onValueChange={(label, translations) => {
                      onChange({
                        ...(value || {}),
                        label,
                        translations,
                        percent: value?.percent ?? "0.00",
                        vote_count: value?.vote_count ?? 0,
                      });
                    }}
                    field="label"
                    placeholder={
                      value?.placeholder && I18n.t(value.placeholder)
                    }
                  />
                )}
              />
              {removeButton(index)}
            </div>
          );
        })}
      </div>
    </>
  );
}
